import { Button, ColorPicker, Select, Slider } from "antd";
import { memo, useState } from "react";
import { MdClose } from "react-icons/md";
import styled from "styled-components";

interface StyleSymbolProps {
    layer: any;
    fields: any[];
    onDeleted: () => void;
}
const StyleSymbol = (props: StyleSymbolProps) => {
    const [textField, setTextField] = useState<string>(props.layer.layout ? props.layer.layout['text-field'][1] : '');
    const [textColor, setTextColor] = useState<string>(props.layer.layout['text-color']);
    const [textSize, setTextSize] = useState<number>(props.layer.layout ? props.layer.layout['text-size'] : 12);
    const [textHaloColor, setCircleStrokeColor] = useState<string>(props.layer.paint['text-halo-color']);
    const [textHaloWidth, setCircleStrokeWidth] = useState<number>(props.layer.paint['text-halo-width']);

    return <>
        <UI_Wrapper>
            <UI_Title_Wrapper>
                <UI_Content_Title>
                    {`Nhãn (${props.layer['source-layer']})`}
                </UI_Content_Title>
                <Button type="text" style={{ padding: 8 }} onClick={() => {
                    props.onDeleted();
                    window.map?.removeLayer(props.layer.id);
                }}>
                    <MdClose color="red" />
                </Button>
            </UI_Title_Wrapper>

            <UI_Content_Row>
                <UI_Content_Row_Label>Trường thuộc tính</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <Select style={{ width: 123 }} value={textField} onChange={(value) => {
                        window.map?.setLayoutProperty(props.layer.id, 'text-field', ['get', value]);
                        setTextField(value);
                    }}
                        showSearch
                    >
                        {props.fields.map((field, index) => {
                            return <Select.Option key={index} value={field.name}>{field.name}</Select.Option>
                        })}
                    </Select>
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Màu nhãn</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <ColorPicker
                        value={textColor}
                        onChange={(value) => {
                            window.map?.setPaintProperty(props.layer.id, 'text-color', value.toHexString());
                            setTextColor(value.toHexString());
                        }}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Kích thước font (px)</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <Slider
                        style={{ width: '100%' }}
                        value={textSize}
                        onChange={(value) => {
                            window.map?.setLayoutProperty(props.layer.id, 'text-size', value);
                            setTextSize(value);
                        }}
                        min={1}
                        max={30}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Màu viền</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <ColorPicker value={textHaloColor} onChange={(value) => {
                        window.map?.setPaintProperty(props.layer.id, 'text-halo-color', value.toHexString());
                        setCircleStrokeColor(value.toHexString())
                    }}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Độ dày viền</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <Slider style={{ width: '100%' }} value={textHaloWidth} onChange={(value) => {
                        window.map?.setPaintProperty(props.layer.id, 'text-halo-width', value);
                        setCircleStrokeWidth(value)
                    }} min={1} max={10} />
                </UI_Content_Row_Value>
            </UI_Content_Row>
        </UI_Wrapper>
    </>;
}

export default memo(StyleSymbol);

const UI_Wrapper = styled.div`
    padding: 8px;
`

const UI_Title_Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`

const UI_Content_Title = styled.div`
    font-size: 13px;
    font-weight: 600;
    margin-right: 8px;
`

const UI_Content_Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`
const UI_Content_Row_Label = styled.div`
    font-size: 14px;
    margin-right: 8px;
    color: #666666;
    flex: 1;
`
const UI_Content_Row_Value = styled.div`
    flex: 1;
`